
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.524 6.727A1 1 0 008 7.58v8.842a1 1 0 001.524.852l7.184-4.421a1 1 0 000-1.704l-7.184-4.42zM6 7.58c0-2.347 2.573-3.785 4.572-2.555l7.184 4.421c1.904 1.171 1.904 3.938 0 5.11l-7.184 4.42C8.573 20.206 6 18.769 6 16.422V7.579z"}})])
          )
        }
      }
    